import { masmovilPalette, llamayaPalette } from './colors'

export const masmovilDatePickerOverride = {
  MuiPickersToolbar: {
    toolbar: {
      backgroundColor: masmovilPalette.secondary.main,
    },
  },
  MuiPickersDay: {
    daySelected: {
      backgroundColor: masmovilPalette.secondary.main,
    },
  },
}

export const llamayaDatePickerOverride = {
  MuiPickersToolbar: {
    toolbar: {
      backgroundColor: llamayaPalette.secondary.main,
    },
  },
  MuiPickersDay: {
    daySelected: {
      backgroundColor: llamayaPalette.secondary.main,
    },
  },
  MuiPickersModal: {
    dialogAction: {
      color: llamayaPalette.secondary.main,
    },
  },
}
